
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ApiOperazioniGrid extends Serenity.EntityGrid<ApiOperazioniRow, any> {
        protected getColumnsKey() { return ApiOperazioniColumns.columnsKey; }
        protected getDialogType() { return ApiOperazioniDialog; }
        protected getIdProperty() { return ApiOperazioniRow.idProperty; }
        protected getInsertPermission() { return ApiOperazioniRow.insertPermission; }
        protected getLocalTextPrefix() { return ApiOperazioniRow.localTextPrefix; }
        protected getService() { return ApiOperazioniService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}